const r=(r,e)=>e.reduce(((e,p,a)=>(e[a%r].push(p),e)),[...Array(r)].map((()=>[])));export{r as columnizeItems};
